export default "__VITE_ASSET__IErinjv4__"